import { CLEAR_PAGE } from '../base/types';
import { FETCH_BANNERS, CREATE_BANNER, UPDATE_BANNER, DELETE_BANNER } from './actionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const bannersReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_BANNERS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_BANNERS}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoading: false,
        isLoaded: true,
      };
    case `${FETCH_BANNERS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case `${CREATE_BANNER}_FULFILLED`:
      return {
        ...state,
        data: [...state.data, payload],
      };
    case `${UPDATE_BANNER}_FULFILLED`:
      return {
        ...state,
        data: state.data.map((i) => {
          if (Number(i.id) === Number(payload.id)) {
            return payload;
          }
          return i;
        }),
      };
    case `${DELETE_BANNER}_FULFILLED`:
      return {
        ...state,
        data: state.data.filter((i) => Number(i.id) !== Number(payload?.id)),
      };

    case CLEAR_PAGE:
      return payload === 'banners' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default bannersReducer;
